module.exports = __webpack_public_path__ + "media/images/flags/16/France-d55143330cfddd83b188910c4a9693ac.png";